export const handleScroll = (
  leftBoxRef,
  setLeftBoxContentHeight,
  setActiveSection,
  leftBoxContentHeight,
  tableOfContents,
) => {
  const customLeftBoxTable = document.getElementById('customLeftBoxTable');
  if (!customLeftBoxTable || !leftBoxRef.current) {
    return;
  }
  
  const scrollPosition = window.scrollY + 140;
  const leftBoxBottom =
    leftBoxContentHeight + leftBoxRef.current.offsetTop - 450;

  if (scrollPosition >= leftBoxBottom) {
    customLeftBoxTable.style.position = 'absolute';
    customLeftBoxTable.style.top = `${leftBoxContentHeight - 350}px`;
  } else if (scrollPosition >= leftBoxRef.current.offsetTop) {
    customLeftBoxTable.style.position = 'fixed';
    customLeftBoxTable.style.top = '140px';
  } else {
    customLeftBoxTable.style.position = 'static';
  }

  const sections = tableOfContents.map((section) => ({
    ...section,
    element: document.getElementById(section.id),
  }));
  setLeftBoxContentHeight(leftBoxRef.current.offsetHeight);
  sections.forEach((section) => {
    if (section.element) {
      const sectionTop = section.element.offsetTop;
      const sectionHeight = section.element.clientHeight;
      if (
        scrollPosition >= sectionTop &&
        scrollPosition < sectionTop + sectionHeight
      ) {
        setActiveSection(section.id);
      }
    }
  });
};

export const handleScrollGetSated = () => {
  const postCard = document.getElementById('PostCard');
  const postCardContainer = document.getElementById('postcard-container');

  postCard.style.position = 'fixed';
  postCard.style.top = '40%';
  postCard.style.right = '0';

  const topElement = postCardContainer.getBoundingClientRect().top;

  if (window.innerWidth > 1200) {
    if (topElement > 800) {
      postCard.style.position = 'fixed';
      postCard.style.top = '40%';
      postCard.style.right = '0';
    } else {
      postCard.style.position = 'absolute';
      postCard.style.top = postCardContainer.offsetTop;
      postCard.style.right = '0';
    }
  } else {
    postCard.style.position = 'relative';
  }
};
